export const MAX_CHARACTER_LIMIT = 1700;
